import { FreeTrialRole, InitUserRole } from "../constants/enums";
import { UUID } from "../types";

export type UserState = {
  hasError: boolean;
  hasUserState: boolean;
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  isEntitled: boolean;
  isEntitledPR: boolean;
  hashedUserId: string;
  acquisitionSource: string;
  userHMAC: string;
  profileComplete: boolean;
  hasInitiatives: boolean;
  hasTasks: boolean;
  isGartnerAssociate: boolean;
  /** @deprecated - stale data issues, use APIs - used only in template-hub, rm with GCOM-4538 when that app is deleted */
  profile: {
    companySize: string;
    industry: string;
    role: string;
    title: string;
    browsingReason: BrowsingReason;
  };
  freeTrialDaysRemaining: number;
  freeTrialRole: FreeTrialRole | "";
  isOnboarded: boolean;
  unreadNotificationCount: number;
  initiatives: { id: UUID; role: InitUserRole }[];
  canStartEvaluation: boolean;
  gcomUserIdHash: string;
};

/** used only in template-hub, rm with GCOM-4538 when that app is deleted */
export enum BrowsingReason {
  EMPTY = "",
  JUST_BROWSING = "JUST_BROWSING",
  READY_TO_START = "READY_TO_START",
}
